/**
 * Masonry
 * 1.0.0
 * 
 * Clones column item from defined count then cycles items to populate each column sequentially
 */
const masonry = () => {
    const $masonries = document.querySelectorAll('[data-masonry');

    $masonries.forEach($masonry => {
        const $contents = $masonry.querySelector('[data-masonry-items]');
        const $items = $contents.querySelectorAll('*');
        const $list = $masonry.querySelector('[data-masonry-list]');
        const $clone = $list.children[0];
        const columnCount = parseInt($list.getAttribute('data-masonry-list'));

        for (let i = 1; i < columnCount; i++) {
            $list.appendChild($clone.cloneNode(true));
        }

        $items.forEach(($item, index) => {
            $list.children[index % columnCount].appendChild($item);
        });

        $contents.remove();
    });
}

document.addEventListener('DOMContentLoaded', masonry);

export default masonry;
